__turbopack_context__.v({
  "brandsType": "CarouselSlide-module-scss-module___VCmhW__brandsType",
  "image": "CarouselSlide-module-scss-module___VCmhW__image",
  "labelText": "CarouselSlide-module-scss-module___VCmhW__labelText",
  "link": "CarouselSlide-module-scss-module___VCmhW__link",
  "noImage": "CarouselSlide-module-scss-module___VCmhW__noImage",
  "otherType": "CarouselSlide-module-scss-module___VCmhW__otherType",
  "slideText": "CarouselSlide-module-scss-module___VCmhW__slideText",
});
